import React from "react";

const InterestContainer = ({ title, description, image, children, initial = false }) => {
    return (
        <div className="flex flex-col items-center justify-center animate-fadeIn text-darkBlue gap-y-[36px] text-center w-full">
            <div className={`flex flex-col items-center justify-center gap-y-[${initial ? '22px' : '6px'}] max-w-[600px]`}>
                <h1 className={`${initial ? 'text-3xl md:text-4xl font-semibold' : 'text-xl md:text-2xl'}`}>{title}</h1>
                {image && <img src={image} alt="logo" className="w-[100px] md:w-[120px] h-[100px] md:h-[120px]" />}
                {description && <p className={`${initial ? 'text-xl md:text-2xl' : 'font-light text-lightBlue'} max-w-[400px]`}>{description}</p>}
            </div>
            <div className="flex flex-col items-center justify-center w-full">
                {children}
            </div>
        </div>
    )
}

export default InterestContainer;
